import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/terms-and-conditions/page.tsx");
